import { Box } from "@mui/material";
import type { FC } from "react";
import { EVENT_LIST, FONT_SIZE, INK, NEUTRAL } from "@/theme/tokens";
import { type LedgerEntry, RequestOriginKind } from "@/utils/models";
import { RequestOriginLedgerList } from "./RequestOriginLedgerList";
import type { OriginCopyContext } from "./requestOriginCopy";

/** What the merged request had been through, inside the step that merged it in. */
export const RequestOriginMergedHistory: FC<{ entry: LedgerEntry; copy: OriginCopyContext; testId: string }> = ({ entry, copy, testId }) => {
	if (entry.details.kind !== RequestOriginKind.MergedIn) return null;
	const { entries, history_complete } = entry.details;
	return (
		<Box sx={{ mt: 1, borderInlineStart: `${EVENT_LIST.CONNECTOR_PX}px solid ${NEUTRAL[200]}`, paddingInlineStart: 1.25 }}>
			{history_complete ? (
				<RequestOriginLedgerList entries={entries} variant="divided" copy={copy} dataTestId={`${testId}-merged`} entryTestIdPrefix={testId} />
			) : (
				<Box sx={{ fontSize: FONT_SIZE.CAPTION, color: INK.MUTED }}>{copy.t("request.origin.sentence.merged_in_incomplete")}</Box>
			)}
		</Box>
	);
};
